import { PlanFeature } from '../../models/plans.model';
import { UserService } from '../../services/UserService';
import { MinusPrimaryIcon, MinusWhiteIcon, PlusPrimaryIcon, PlusWhiteIcon } from '../../icon';

interface Props {
    min?: number;
    count: number;
    id?: string;
    max?: number;
    onChange: (count: number, id?: string) => void;
    IsMobileDevice: boolean;
    inverted?: boolean;
    Features?: PlanFeature[];
}

const CounterComponent = (props: Props) => {

    const handleChange = (count: number) => {
        if (count >= 0 && count <= (props.max || Number.MAX_VALUE)) {
            props.onChange(count, props.id);
        }
    }

    const isCounterEnabled = () => {
        if (!UserService.hasSysAdminRole()) {
            return !props.Features?.filter(x => x?.Label.toLowerCase().includes("10dlc")).length
        }
        else
            return true
    }

    return <div className={`align-center d-flex ${props.IsMobileDevice ? `` : `h-4`}`}>
        <div className={` ${props.IsMobileDevice ? `w-3` : `w-5`}`}>
            <button className={`w-fill ${props.IsMobileDevice ? `h-3` : ``} h3-bold counter-btn${props.inverted ? "-inverted" : ""}${props.count <= (props.count <= 0 || typeof Number.NEGATIVE_INFINITY === "number" ? Number.NEGATIVE_INFINITY : 0) ? "-disabled" : ""} left  d-flex`} onClick={(e: any) => { e.preventDefault(); handleChange(props.count - 1) }} >
                {props.inverted ? <MinusPrimaryIcon className="m-auto" /> : <MinusWhiteIcon className="m-auto" />}</button>
        </div>
        <div className={`${props.IsMobileDevice ? `w-3 h-3` : `w-4 h-4`}  d-flex counter${props.inverted ? "-inverted" : ""}`}>
            <span className="m-auto h3-bold">{props.count}</span>
        </div>
        <div className={` ${props.IsMobileDevice ? `w-3` : `w-5`}`}>
            <button className={`w-fill ${props.IsMobileDevice ? `h-3` : ``} h3-bold ${isCounterEnabled() ? `counter-btn-${props.inverted ? "-inverted" : ""}` : "counter-btn-disabled"} counter-btn${props.inverted ? "-inverted" : ""}${props.count >= (props.max || Number.MAX_VALUE) ? "-disabled" : ""} right d-flex`} onClick={(e: any) => { e.preventDefault(); isCounterEnabled() && handleChange(props.count + 1) }} >{props.inverted ? <PlusPrimaryIcon className="m-auto" /> : <PlusWhiteIcon className="m-auto" />}
            </button>
        </div>
    </div>
}

export default CounterComponent;